import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  settings : [],
  banners : [],
  error : null
};


export const SETTING_URL = "admin/settings";

export const getSettings = createAsyncThunk(
    SETTING_URL + "/get-settings",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(SETTING_URL);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const updateSettings = createAsyncThunk(
  SETTING_URL + "/update-settings",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(SETTING_URL, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const updateBanner = createAsyncThunk(
  SETTING_URL + "/banner",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(SETTING_URL + "/banner", formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const getBanner = createAsyncThunk(
  SETTING_URL + "/get-banner",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(SETTING_URL + "/banner");
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

const settingSlice = createSlice({
    name : "setting",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(getSettings.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getSettings.fulfilled, (state, action) => {
                state.isLoading = false;
                state.settings = action.payload;
            })
            .addCase(getSettings.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(updateSettings.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(updateSettings.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(updateSettings.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(updateBanner.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(updateBanner.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(updateBanner.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getBanner.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getBanner.fulfilled, (state, action) => {
                state.isLoading = false;
                state.banners = action.payload;
            })
            .addCase(getBanner.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default settingSlice.reducer